import { Controller, FieldValues } from 'react-hook-form'
import { IFormComponent_v2 } from './helper'
import {
    FormControl,
    FormControlLabel,
    FormControlProps,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
    RadioGroupProps,
    RadioProps,
} from '@mui/material'
import { ReactNode } from 'react'

export const FormRadioGroup = <T extends FieldValues>({
    control,
    name,
    options,
    radioGroupProps,
    radioProps,
    formControlProps,
    formLabel,
}: IFormComponent_v2<T> & {
    options: { label: string; value: any; radioProps?: RadioProps }[]
    formControlProps?: FormControlProps
    radioGroupProps?: RadioGroupProps
    radioProps?: RadioProps
    formLabel?: ReactNode
}) => {
    return (
        <Controller
            control={control}
            name={name}
            render={(props) => (
                <FormControl
                    {...formControlProps}
                    data-testid={`form-control-${name}`}
                    error={Boolean(props.fieldState.error)}
                >
                    {formLabel ? <FormLabel sx={{mb: 1.5}}>{formLabel}</FormLabel> : null}
                    <RadioGroup
                        {...radioGroupProps}
                        value={props.field.value || null}
                        onChange={props.field.onChange}
                    >
                        {options.map((el, i) => (
                            <FormControlLabel
                                key={`radioLabel_${name}_${i}`}
                                name={`${name}_${el.value}`}
                                value={el.value}
                                label={el.label}
                                control={
                                    <Radio {...radioProps} {...el.radioProps} />
                                }
                            />
                        ))}
                    </RadioGroup>
                    <FormHelperText>
                        {props.fieldState.error?.message}
                    </FormHelperText>
                </FormControl>
            )}
        />
    )
}
